export default __webpack_public_path__ + "static/media/INXC.cad2c7ae.png";